import React, { FunctionComponent } from 'react';
import { Typography } from '@material-ui/core';
import Translation from '../../../../../../../common/components/translation/Translation';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';
import IMoney from '../../../../../../../gqlCommon/model/prices/IMoney';
import featureColorPriceStyles from './featureColorPriceStyles';

interface IFeatureColorPrice {
  price?: IMoney;
}

const FeatureColorPrice: FunctionComponent<IFeatureColorPrice> = ({ price }) => {
  const styles = featureColorPriceStyles();

  if (!price) {
    return null;
  }

  if (price.amount === 0) {
    return (
      <Typography component={'span'} variant={'caption'} className={styles.included}>
        <Translation id="trans__configurator__customise_page_interior_section__included" />
      </Typography>
    );
  }

  return (
    <Typography component={'span'} variant={'caption'} className={styles.price}>
      {'(+ '}
      <Price
        price={price.amount}
        component={'span'}
        variant={'caption'}
        className={styles.price}
        priceDisplayType={PriceDisplayType.PRIMARY}
      />
      {')'}
    </Typography>
  );
};

export default FeatureColorPrice;
